// src/authConfig.js
// ─── Azure AD / MSAL ────────────────────────────────────────────────────────
export const msalConfig = {
  auth: {
    clientId:    process.env.REACT_APP_CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation:       "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const sharePointScopes = {
  scopes: [
    `${process.env.REACT_APP_SHAREPOINT_TENANT}/.default`,
  ],
};

// ─── SharePoint config ───────────────────────────────────────────────────────
export const sharePointConfig = {
  siteUrl:  process.env.REACT_APP_SHAREPOINT_SITE_URL,
  listName: process.env.REACT_APP_SHAREPOINT_LIST_NAME,
  fields: {
    productCode:         process.env.REACT_APP_COL_PRODUCT_CODE   || "ProductCode",
    programName:         process.env.REACT_APP_COL_PROGRAM_NAME   || "Title",
    practice:            process.env.REACT_APP_COL_PRACTICE        || "Practice",
    solutionType:        process.env.REACT_APP_COL_SOLUTION_TYPE   || "SolutionType",
    coverEmail:          process.env.REACT_APP_COL_COVER_EMAIL     || "CoverEmailUrl",
    approachNote:        process.env.REACT_APP_COL_APPROACH_NOTE   || "ApproachNoteUrl",
    successStory:        process.env.REACT_APP_COL_SUCCESS_STORY   || "SuccessStoryUrl",
    discoveryQuestions:  process.env.REACT_APP_COL_DISCOVERY_QUESTIONS || "DiscoveryQuestions",
    priority:            process.env.REACT_APP_COL_PRIORITY        || "Priority",
    isNew:               process.env.REACT_APP_COL_IS_NEW          || "IsNew",
    isActive:            process.env.REACT_APP_COL_IS_ACTIVE       || "IsActive",
    expiry:              process.env.REACT_APP_COL_EXPIRY          || "ExpiryDate",
    modified:            "Modified",
  },
};
